import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { DBResponse } from "@/entities/IDBResponse";
import type { NftOwner } from "@/entities/IOwner";
import { commonApiFetch } from "@/services/api/common-api";
interface UseNftBalanceProps {
  consolidationKey: string | null;
  contract: string;
  tokenId: number;
}
export function useNftBalance(t0) {
  const $ = _c(13);
  const {
    consolidationKey,
    contract,
    tokenId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== consolidationKey || $[1] !== contract || $[2] !== tokenId) {
    t1 = ["nft-balance", consolidationKey, contract, tokenId];
    t2 = async () => await commonApiFetch({
      endpoint: `nft-owners/consolidation/${consolidationKey}?contract=${contract}&token_id=${tokenId}`
    });
    $[0] = consolidationKey;
    $[1] = contract;
    $[2] = tokenId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  const t3 = !!consolidationKey;
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    data,
    isLoading,
    error
  } = useQuery(t4);
  const balanceObject = data?.data?.[0];
  const balance = balanceObject?.balance ?? 0;
  let t5;
  if ($[9] !== balance || $[10] !== error || $[11] !== isLoading) {
    t5 = {
      balance,
      isLoading,
      error
    };
    $[9] = balance;
    $[10] = error;
    $[11] = isLoading;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}